import React, { useEffect, useState } from 'react';
import CustomCard from '../../../../components/Common/CustomCard';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { createSelector } from 'reselect';
import * as Yup from "yup"
import { editAccountSetting, resetAccountsettingReset } from '../../../../store/menu/application/actions';
import { CustomToast } from '../../../../components/Lystface/Common/CustomToast';
import CustomLoader from '../../../../components/Common/CustomLoader';
import Content from './content';
import form_messages from '../../../../constants/form_messages';
import { imageValidation } from '../../../../config';
import form_input_patterns from '../../../../constants/form_input_patterns';
import { isEqual } from 'lodash';
import CustomPopup from '../../../../components/Common/CustomPopup';

const Account = ({ loadingGetAccountDetail }) => {
    const [applicationStatus, setApplicationStatus] = useState('manage');
    const { maxFileSize, allowedFormats } = imageValidation

    const dispatch = useDispatch();

    const selectAccountSetting = state => state.Application;
    const state = useSelector(state => state.Application)
    const responseAccountSetting = createSelector(selectAccountSetting, account => ({
        firstName: account.getAccountData?.data?.first_name,
        lastName: account.getAccountData?.data?.last_name,
        role: account.getAccountData?.data?.job_role,
        user_icon_profile: account.getAccountData?.data?.user_icon,
        company: account.getAccountData?.data?.cmp_name,
        responseStatus: account.editAccountSetting.responseStatus,
        responseMessage: account.editAccountSetting.responseMessage,
        loading: account.editAccountSetting.loading,
        accountData: account.getAccountData?.data
    }))
    const {
        firstName,
        lastName,
        role,
        company,
        responseMessage,
        responseStatus,
        loading,
        user_icon_profile,
        accountData
    } = useSelector(responseAccountSetting);
    const [profileIcon, setProfileIcon] = useState(null)
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const [isremoved, setIsremoved] = useState(false)
    const [croppedImage, setCroppedImage] = useState(null)
    const [validationMessage, setValidationMessage] = useState(null);



    useEffect(() => {
        if (accountData) {
            let accountProfile = accountData?.profile_icon ? accountData?.profile_icon : accountData?.user_icon
            setProfileIcon(accountProfile)
        }
    }, [accountData])

    const initialValuesForForm = {
        firstName: firstName,
        lastName: lastName,
        company: company,
        role: role,
    }
    const validationType = useFormik({
        enableReinitialize: true,
        initialValues: initialValuesForForm,
        validationSchema: Yup.object().shape({
            firstName: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("First name")
                )
                .min(1, form_messages.Signup.firstname.MIN1MAX35)
                .max(35, form_messages.Signup.firstname.MIN1MAX35)
                .trim()
                .required(form_messages.Signup.firstname.Required),
            lastName: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Last name")
                )
                .min(1, form_messages.Signup.lastname.MIN1MAX35)
                .max(35, form_messages.Signup.lastname.MIN1MAX35)
                .trim(),
            role: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Role")
                )
                .min(3, form_messages.Signup.jobrole.MIN3MAX20)
                .max(20, form_messages.Signup.jobrole.MIN3MAX20)
                .trim()
                .required(form_messages.Signup.jobrole.Required),
            company: Yup.string()
                .matches(
                    form_input_patterns.ONLYENGLISHTEXT,
                    form_messages.Common.INVALID("Company name")
                )
                .min(3, form_messages.Signup.companyname.MIN3MAX100)
                .max(100, form_messages.Signup.companyname.MIN3MAX100)
                .trim()
                .required(form_messages.Signup.companyname.Required),
        }),
        onSubmit: async values => {
            const formData = new FormData();
            formData.append("first_name", values.firstName.trim());
            formData.append("last_name", values.lastName.trim());
            if (values.role) {
                formData.append("job_role", values.role.trim());
            }
            formData.append("cmp_name", values.company.trim());
            if (profileIcon || values.user_icon_file) {
                formData.append('user_icon', values.user_icon_file ? values.user_icon_file : profileIcon);
            }
            dispatch(editAccountSetting({ formData: formData, user_icon: croppedImage ? croppedImage : null, user_deleted: !profileIcon && !croppedImage }))
        },
    });

    const onSubmitForm = () => {
        validationType.handleSubmit()
        return false
    }

    useEffect(() => {
        if (responseStatus === 'Success') {
            setApplicationStatus('manage');
        }
        if (responseStatus && responseMessage) {
            CustomToast({
                message: responseStatus === 'Error' ? responseMessage : responseMessage,
                status: responseStatus === 'Error' ? 'failure' : 'success',
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            dispatch(resetAccountsettingReset())
        }
    }, [responseStatus])

    const onClickDiscard = () => {
        validationType.resetForm()
        setApplicationStatus('manage')
        // setProfileIcon(user_icon_profile)
        setCroppedImage(null);
        setPopupDetails({ open: false })

    }

    const handleCloseDiscardPopup = () => {
        setPopupDetails({ open: false })
    }

    const onCancelForm = () => {
        const isValuesNotChanged = isEqual(validationType.values, initialValuesForForm)
        if (isValuesNotChanged) {
            onClickDiscard();
        }
        else {
            setPopupDetails({
                open: true, title: 'accountModification', titleText: 'Discard Changes', bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Discard', handleClickPrimaryButton: onClickDiscard, handleClose: handleCloseDiscardPopup
            })
        }
    }

    const onClickEdit = () => {
        validationType.resetForm()
        setApplicationStatus(false)
    }

    let buttonDetails = [
        {
            'buttonText': 'Cancel', buttonType: 'secondary', callBackFunction: () => { onCancelForm() }
        },
        { 'buttonText': 'Save', buttonType: 'primary', callBackFunction: () => onSubmitForm() }
    ]

    if (applicationStatus === 'manage') {
        buttonDetails = [
            { 'buttonText': 'Edit', buttonType: 'primary', callBackFunction: () => { onClickEdit() } },
        ]
    }

    const handlePhotoUplaod = (e, from) => {
        let file;
        if (from === "drag") {
            file = e.dataTransfer.files[0];

        }
        else {
            file = e.currentTarget.files[0];

        }
        const validImageTypes = allowedFormats; // Add more types as needed
        const maxSize = maxFileSize * 1024 * 1024; // 1MB in bytes
        const formatsList = validImageTypes.map((format) => format.split('/')[1]?.toUpperCase()).join(",")
        if (file) {
            if (validImageTypes.includes(file.type)) {
                if (file.size > maxSize) {
                    setValidationMessage("Unsupported image size. Please upload a valid image file.")


                }
                else {
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        validationType.setFieldValue("cropIcon", reader.result)
                        validationType.setFieldValue("user_icon_file", file)
                        validationType.setFieldTouched("cropIcon", true, false);
                        validationType.validateForm();
                    }
                    reader.readAsDataURL(file);
                    setValidationMessage(null)

                }
                setIsremoved(!isremoved)
            } else {
                setValidationMessage("Unsupported image format. Please upload a valid image file.")

            }

        }

    }

    const handleDeleteIcon = () => {
        setProfileIcon(null)
        validationType.setFieldValue("cropIcon", null)
        validationType.setFieldValue("user_icon", null)
        validationType.setFieldValue("user_icon_file", null)
        setFileInputKey(Date.now());


    }
    return (
        <div className={'profile-container'}>
            <CustomCard
                titleText={"My profile"}
                buttonsList={!loadingGetAccountDetail && buttonDetails}
                applicationLoading={loading}
            >
                {!loadingGetAccountDetail && (
                    <Content
                        user_icon_profile={user_icon_profile}
                        applicationStatus={applicationStatus}
                        handlePhotoUplaod={handlePhotoUplaod}
                        validationType={validationType}
                        firstName={firstName}
                        company={company}
                        handleDeleteIcon={handleDeleteIcon}
                        profileIcon={profileIcon}
                        fileInputKey={fileInputKey}
                        accountData={accountData}
                        setFileInputKey={setFileInputKey}
                        isremoved={isremoved}
                        setCroppedImage={setCroppedImage}
                        croppedImage={croppedImage}
                        validationMessage={validationMessage}
                        setValidationMessage={setValidationMessage}
                    />
                )}
                {loadingGetAccountDetail &&
                    <div className='empty-view'>
                        <CustomLoader text={"Fetching acount details...."} />
                    </div>
                }
            </CustomCard>
            {popupDetails.open &&
                <CustomPopup
                    popupDetails={popupDetails}
                />
            }
        </div>
    )
}

export default Account;